import React, { useEffect, useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { TPhaseCountsOfGeneralSeaAreasItem } from '../../kpiTypes';
import { ChartContainer } from '../../../../shared/components/charts/ChartContainer';

export interface IGeneralSeaAreaOperationalPhaseChartProps {
	chartKey: number;
	phaseCountsOfGeneralSeaAreasData: TPhaseCountsOfGeneralSeaAreasItem[];
}

const GeneralSeaAreaOperationalPhaseChart: React.FC<IGeneralSeaAreaOperationalPhaseChartProps> = ({ ...props }) => {
	const data = Array.isArray(props.phaseCountsOfGeneralSeaAreasData) ? props.phaseCountsOfGeneralSeaAreasData : [];
	const [options, setOptions] = useState<AgChartOptions>({
		data: data,
		title: {
			enabled: false,
			text: 'Geographical Distribution',
			textAlign: 'left',
		},
		series: [
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'generalSeaArea',
				yKey: 'countOfPhaseAnchored',
				yName: 'Anchored',
				fill: '#183d57',
				stacked: true,
			},
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'generalSeaArea',
				yKey: 'countOfPhaseAtBerth',
				yName: 'At Berth',
				fill: '#f0d035',
				stacked: true,
			},
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'generalSeaArea',
				yKey: 'countOfPhaseAtSea',
				yName: 'At Sea',
				fill: '#1e503e',
				stacked: true,
			},
			{
				type: 'bar',
				direction: 'horizontal',
				xKey: 'generalSeaArea',
				yKey: 'countOfPhaseManoeuvring',
				yName: 'Manoeuvring',
				fill: '#7cb5ec',
				stacked: true,
			},
		],
		axes: [
			{
				type: 'category',
				position: 'left',
				title: {
					enabled: false,
					text: 'Sea Area',
				},
				label: {
					fontSize: 12,
					autoRotate: true,
				},
				tick: {
					enabled: true,
				},
			},
			{
				type: 'number',
				position: 'bottom',
				title: {
					enabled: false,
					text: '#Hours',
				},
				nice: false,
			},
		],
		legend: {
			position: 'bottom',
		},
	});

	useEffect(() => {
		if(!props.phaseCountsOfGeneralSeaAreasData || props.phaseCountsOfGeneralSeaAreasData.length === 0) {
			return;
		}

		const filteredData = props.phaseCountsOfGeneralSeaAreasData.filter((item) => {
			return (
				item.countOfPhaseAnchored > 0 ||
				item.countOfPhaseAtBerth > 0 ||
				item.countOfPhaseAtSea > 0 ||
				item.countOfPhaseManoeuvring > 0
			);
		});
		const sortedData = filteredData.sort((a, b) => {
			const totalCountA = a.countOfPhaseAnchored + a.countOfPhaseAtBerth + a.countOfPhaseAtSea + a.countOfPhaseManoeuvring;
			const totalCountB = b.countOfPhaseAnchored + b.countOfPhaseAtBerth + b.countOfPhaseAtSea + b.countOfPhaseManoeuvring;
			return totalCountB - totalCountA;
		});
		setOptions((prevOptions) => ({
			...prevOptions,
			data: sortedData,
		}));
	}, [props.phaseCountsOfGeneralSeaAreasData]);

	return <ChartContainer
				data={options.data}
				filename="general_sea_area_operational_phase_counts_chart"
				buttonPosition="top-right"
			>
				<AgCharts key={props.chartKey} options={options} className="w-full h-full pt-1" />
			</ChartContainer>
};

export default GeneralSeaAreaOperationalPhaseChart;
